import styled from "styled-components"
import {Col as BaseCol} from "react-bootstrap"

export const BackGround = styled.div`
  transition: all 0.1s ease;
  background-color: ${(props) => props.color};
  height: 100vh;
`

export const Col = styled(BaseCol)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`
